// extracted by mini-css-extract-plugin
export default {"iconName":"MainNavigation_iconName__jLWjW","logout_btn":"MainNavigation_logout_btn__AL0DG","navbar":"MainNavigation_navbar__8ZtZj","logo_cs":"MainNavigation_logo_cs__olXQB"};